var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconHeart48Filled = function SvgIconHeart48Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.274 17.332a9.24 9.24 0 0 0-15.27-4 9.24 9.24 0 0 0-15.27 4c-1.07 3.41-.15 6.74 2.66 9.64.81.84 5.27 5.31 8.86 8.9a5.281 5.281 0 0 0 7.49 0c3.6-3.59 8.05-8.06 8.87-8.9 2.8-2.9 3.74-6.23 2.66-9.64Z",
    fill: "current"
  })));
};
export default SvgIconHeart48Filled;